const statementsES = {
    "view": {
        "table": {
            "title": "Tu lista de Estados de Cuenta",
            "column": {
                "type": "Tipo",
                "year": "Año",
                "month": "Mes",
                "issue_year": "Año de Emisión",
                "issue_month": "Mes de Emisión",
                "description": "Descripción",
                "amount": "Cantidad",
                "status": "Estado",
                "details": "Detalles",
                "overview": "Resumen"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "label": {
                "status_open": "Abierto",
                "status_paid": "Pagado",
                "type_licensing": "Licenciamiento",
                "type_regular": "Regular",
                "type_audio_mastering_services": "Masterización de Audio - Servicios",
                "type_vinyl_earnings": "Ganancias de Vinilo",
                "type_offset": "Compensación",
                "type_not_known": "No Conocido",
                "month_january": "Enero",
                "month_february": "Febrero",
                "month_march": "Marzo",
                "month_april": "Abril",
                "month_may": "Mayo",
                "month_june": "Junio",
                "month_july": "Julio",
                "month_august": "Agosto",
                "month_september": "Septiembre",
                "month_october": "Octubre",
                "month_november": "Noviembre",
                "month_december": "Diciembre"
            },
            "button": {
                "download": "Descargar",
                "exportCsv": "Exportar CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Tu plan de suscripción actual no admite esta función. Por favor, <1>actualiza</1> tu plan de suscripción para disfrutar de esta función.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor, <1>reanuda</1> tu suscripción para disfrutar de esta función.",
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información."
        }
    }
};

export default statementsES;